// eslint-disable-next-line @typescript-eslint/ban-types
export const isFunction = (argument: any): argument is Function => typeof argument === 'function'
